export const subscription = {
  titles: {
    subscription: "Abbonamento",
    freeTrial: "Prova gratuita",
    expired: "Scaduto",
  },

  status: {
    active: "Attivo",
    canceled: "Annullato",
    trialAccess: "PROVA GRATUITA",
    expiredAccess: "ACCESSO SCADUTO",
  },

  notices: {
    activeDesc: "Gestisci i dettagli del tuo abbonamento e le opzioni di upgrade.",
    canceledDesc:
      "Il tuo abbonamento è stato annullato. Manterrai l'accesso fino alla data di scadenza.",
    trialDesc: "Hai accesso alle funzionalità del sistema fino alla data di scadenza.",
    expiredDesc:
      "Il tuo periodo di prova è terminato. Abbonati per continuare a usare il servizio.",
    upgradeHint:
      "Non perdere l'accesso alle funzionalità avanzate, aggiorna subito il tuo abbonamento",
    expiredHint:
      "Il tuo accesso è scaduto. Abbonati per continuare a usare tutte le funzionalità",
    needFullAccess: "Ti serve l'accesso completo?",
    choosePlan: "Scegli il piano più adatto a te",
  },

  labels: {
    planActive: "Piano attivo",
    stateNow: "Stato attuale",
    trialPeriod: "Periodo di prova",
    periodExpired: "Periodo scaduto",
    summary: "Riepilogo dell'abbonamento",
    timeLeft: "Tempo rimanente",
    trialExpiresIn: "La tua prova gratuita scade tra {days} giorni",
    expirationDate: "Data di scadenza",
    nextRenewal: "Prossimo rinnovo",
    accessUntil: "Accesso disponibile fino al",
    perUnit: "/ Per {unit}",
    unitRoom: "Camera",
    unitRoomMultiple: "Più camere",
    unitApartment: "Appartamento",
    unitVilla: "Villa",
    unitCamping: "Campeggio",
    unitLodging: "Alloggio",
    annualPlan: "Piano annuale",
    monthlyPlan: "Piano mensile",
  },

  actions: {
    addUnit: "Aggiungi {unitLabel}",
    manageSubAndPayment: "Gestisci abbonamento e metodo di pagamento",
    processing: "Elaborazione in corso...",
    subscribeNow: "Abbonati ora",
    chooseAPlan: "Scegli un piano",
    goToSubscriptionPage: "Vai ai piani",
  },

  confirmCancel: {
    title: "Annullare l'abbonamento?",
    text: "Se annulli, perderai l'accesso ai tuoi servizi.",
    confirm: "Sì, annulla",
    cancel: "No",
  },

  formats: {
    priceTotalHTML: "{price}",
    dateDDMMYYYY: "{date}",
  },

  modal: {
    title: 'Abbonamento attivato!',
    details: "Dettagli dell'abbonamento",
    welcomeTitle: "Benvenuto in WA Checkin {plan}!",
    welcomeBody:
      "Ora hai accesso completo ai nostri strumenti di check-in su WhatsApp, sincronizzazione OTA, chatbot IA, automazioni e molto altro.",
    feature1: {
      title: "Gestisci tariffe e disponibilità",
      desc: "Modifica facilmente i tuoi prezzi e controlla l'occupazione in tempo reale, tutto da un unico posto.",
    },
    feature2: {
      title: "Ottieni prenotazioni dirette",
      desc: "Dal tuo sito web, gli ospiti possono prenotare direttamente senza passare dalle OTA.",
    },
    schedule: {
      help: "Prenota una videochiamata gratuita e ti aiuteremo a configurare tutto.",
      cta: "Prenota una videochiamata",
    },
  },

  sectionPlans: {
    title: "Elenco dei piani",
    confirm: {
      header: "Conferma l'upgrade del piano",
      loadingMsg: "Aggiornamento del piano in corso, attendi.",
      body: "Stai per cambiare il piano del tuo account in {plan}.",
    },
    actions: {
      cancel: "Annulla",
      confirmUpgrade: "Conferma upgrade",
      goToBilling: "Vai ai metodi di fatturazione",
      accept: "OK",
      updateSubscription: "Aggiorna abbonamento", // NEW
    },
    success: {
      title: "Operazione riuscita",
      body: "Il tuo abbonamento è stato aggiornato.",
    },
    errors: {
      processTitle: "Errore durante l'elaborazione della richiesta",
      unknownUpdate: "Errore sconosciuto durante l'aggiornamento dell'abbonamento.",
      genericTitle: "Errore",
      genericBody: "Impossibile aggiornare l'abbonamento.",
    },
  },

  plans: {
    features: {
      installation: "Onboarding personalizzato con un esperto",
      fastSupport: "Assistenza rapida via email, chat e telefono",
      whatsappCheckin: "Check-in tramite WhatsApp",
      linkEmailCheckin: "Check-in tramite link / email",
      welcomeMessage: "Messaggio di benvenuto tramite WhatsApp ed email",
      digitalSignature: "Firma digitale delle politiche",
      idScanner: "Scanner di documenti d'identità/passaporto",
      sesHospedajesSend: "Invio automatico dei rapporti alla polizia",
      reviewLink: "Invio del link per la recensione Google dopo il check-out",
      smartLocks: "Collegamento con le tue serrature intelligenti",
      channelManager1: "Channel Manager (connessione con 1 OTA)",

      includesLite: "Tutto ciò che è incluso in Lite",
      selfieVerification: "Verifica dell'ospite al check-in con selfie",
      unifiedInbox: "Casella di posta unificata",
      upsellServices: "Offri servizi ed esperienze tramite WhatsApp",
      paymentLinks: "Addebiti agli ospiti (link di pagamento con carta)",
      websiteBookings: "Sito web di prenotazione con calendario sincronizzato",
      channelManagerUnified: "Channel Manager (calendari unificati, oltre 100 OTA)",
      channelManagerCentralPrices:
        "Channel Manager (gestione centralizzata dei prezzi)",
      guestSupportOption: "Opzione per attivare il Guest Support",

      includesStandard: "Tutto ciò che è incluso in Standard",
      centralizedPriceManager: "Gestore centralizzato dei prezzi",
      aiChatbot: "Chatbot IA per WhatsApp (FAQ e automazione)",
      googleVacationRentals: "Integrazione con Google Vacation Rentals",
      whatsappReminders: "Promemoria WhatsApp per gli ospiti",
      eInvoicingSoon: "Fatturazione elettronica (prossimamente)",
      prioritySupport: "Assistenza prioritaria",
    },
  },

  planCard: {
    perSlash: "/per", // separator "/per {unit}"
    infoTitle: "Dettagli del piano",
    update: "Aggiorna",
    subscribe: "Abbonati",
    currentPlan: "Piano attuale",
    byApartment: "per appartamento",
    byVilla: "per villa",
    byCamping: "per piazzola",
    byRoom: "per camera",
    byUnit: "per unità",
  },

  services: {
    title: "Servizi aggiuntivi",
    ctaComingSoon: "Prossimamente",
    guestSupport: {
      title: "Servizio Guest Support",
      subtitle: "Gestiamo noi per te i messaggi WhatsApp e le chiamate telefoniche dei tuoi ospiti.",
      desc: "Li assistiamo con il check-in, rispondiamo alle loro domande e gestiamo anche le chiamate per le prenotazioni dirette. Tu ti rilassi mentre loro vivono un'esperienza da 10 e lode fin dal primo contatto.",
    },
    chatbot: {
      title: "ChatBot IA",
      activeService: "Servizio attivo",
      desc: "Aggiungi il servizio chatbot IA e automatizza le richieste dei tuoi ospiti in modo rapido ed efficiente.",
      activateCta: "Attiva servizio",
      confirm: {
        header: "Conferma attivazione",
        loadingMsg: "Attivazione del servizio ChatBot in corso, attendi.",
        body: "Stai per attivare il servizio ChatBot IA per le tue {units} proprietà.",
      },
      discount: {
        applied: "Sconto applicato:",
        couponFallback: "Coupon",
      },
      pricing: {
        unitPrice: "Prezzo unitario:",
        quantity: "Quantità:",
        totalToPay: "Totale da pagare:",
      },
    },
  },

  invoices: {
    title: "Fatture e ricevute",
    created: "Creata",
    status: "Stato",
    amount: "Importo",
    paid: "Pagata",
    unpaid: "Non pagata",
    viewInvoice: "Visualizza fattura",
    empty: "Non hai ancora nessuna fattura.",
  },

  updateModal: {
    header: "Aggiungi {unitLabel}",
    body: "Aggiungi il numero di {unitLabelPlural} al tuo abbonamento.",
    pricing: {
      discountApplied: "Sconto applicato all'abbonamento:",
      unitPrice: "Prezzo unitario:",
      quantity: "Quantità:",
      totalNewUnits: "Totale per le nuove unità:",
      newSubscriptionTotal: "Nuovo valore totale dell'abbonamento:",
    },
    prorationNote:
      "Le modifiche all'abbonamento vengono calcolate in modo proporzionale in base ai giorni rimanenti nel periodo corrente. L'addebito completo verrà applicato il mese successivo.",
  },

  page: {
    findRightPlan: "Trova il piano giusto per te",
    enterAmount: "Inserisci l'importo",
    numberOf: "Numero di {unit}"
  },
  billing: {
    title: "Seleziona il periodo di fatturazione",
    subtitle: "Scegli come vuoi pagare",
    monthly: "Mensile",
    annual: "Annuale",
    discountShort: "−{percent}%",
  },
};
